import http from '@/utils/http'

export function insertMessageBoard(data) {
    return http.post("/api/weixin/leaveMessage", data);
}

export function countMessageBoard() {
	return http.get("/api/weixin/countLeaveMessages")
}

export function fetchMessageBoard() {
    return http.get("/api/weixin/leaveMessages/all")
}
